"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorSwatch = exports.ColorSwatchRep = exports.COLORMOODS = exports.ColorRepresentations = void 0;

class ColorRepresentations {}

exports.ColorRepresentations = ColorRepresentations;
ColorRepresentations.RGB = 'RGB';
const COLORMOODS = Object.freeze({
  Colorful: 'DL_COLOR_MOODS_COLORFUL',
  Bright: 'DL_COLOR_MOODS_BRIGHT',
  Muted: 'DL_COLOR_MOODS_MUTED',
  Deep: 'DL_COLOR_MOODS_DEEP',
  Dark: 'DL_COLOR_MOODS_DARK',
  None: 'DL_COLOR_MOODS_BLANK'
});
exports.COLORMOODS = COLORMOODS;

class ColorSwatchRep {
  constructor(value, mode = 'RGB', profileName = 'sRGB IEC61966-2.1') {
    this.mode = ColorRepresentations.RGB;
    this.value = {};
    this.profileName = 'sRGB IEC61966-2.1';
    this.mode = mode;
    this.value = value;
    this.profileName = profileName;
  }

}

exports.ColorSwatchRep = ColorSwatchRep;

class ColorSwatch {
  constructor(swatch) {
    this.swatches = [];

    switch (swatch.mode) {
      case ColorRepresentations.RGB:
        this.swatches.push(swatch);
        break;
      //TODO: Handle other color spaces
    }
  }

  getRGBRepresentation() {
    return this.swatches.find(swatch => swatch.mode === ColorRepresentations.RGB);
  } // noinspection JSUnusedGlobalSymbols


  toJSON() {
    return this.swatches;
  }

}

exports.ColorSwatch = ColorSwatch;